<template>
  <v-navigation-drawer
    id="appDrawer"
    :mini-variant.sync="mini"
    fixed
    :light="$vuetify.light"
    app
    v-model="drawer"
    width="232px"
  >
    <v-toolbar class="bg-white mb-4">
      <div class="text-xs-center mt-2">
          <img v-bind:src="require('../assets/ListBuy.png')" width="60%" height="67%" alt="IderaOS Delivery">
      </div>
      <v-toolbar-title class="ml-0 pl-3"></v-toolbar-title>
    </v-toolbar>
    <ul class="sidebar-ul">
        <li v-for="(item, i) in menus" :key="i">
           <router-link class="route-link" :to="{name: `${item.name}`}" v-if="!item.items"><v-icon class="pr-2">{{item.icon}}</v-icon> {{item.title}}</router-link> 
           <a href="#" @click="toggleMenu(`_${i}`); return false" class="route-link white--text" v-if="item.items"><v-icon class="pr-2">{{item.icon}}</v-icon> {{item.title}} <span class="material-icons">keyboard_arrow_down</span></a>
            <ul v-if="item.items" :id="'_'+i" class="collapse-ul">
                <li v-for="subItem in item.items"><router-link :to="{name: `${subItem.component}`}" class="route-link">{{subItem.title}}</router-link></li>
            </ul>
        </li>
        <li>
           <router-link class="route-link" :to="`/store/${store_url}`" target="_blank"><v-icon class="pr-2">shop</v-icon> Visit store</router-link> 
        </li>
    </ul>
    
  </v-navigation-drawer>
</template>
<script>
import menu from "@/api/menu";
export default {
  name: "app-drawer",
  components: {},
  props: {
    expanded: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    mini: false,
    drawer: true,
    menus: menu,
    scrollSettings: {
      maxScrollbarLength: 160
    },
  }),
  computed: {
    computeGroupActive() {
      return true;
    },
    computeLogo() {
      return "/static/Logo.png";
    },

    sideToolbarColor() {
      return this.$vuetify.options.extra.sideNav;
    },
    store_url() {
      return window.$cookies.get('store_url') || this.$store.getters.getStore;
  }
  },
  created() {
    window.getApp.$on("APP_DRAWER_TOGGLED", () => {
      this.drawer = !this.drawer;
    });
  },

  methods: {
    genChildTarget(item, subItem) {
      if (subItem.href) return;
      if (subItem.component) {
        return {
          name: subItem.component
        };
      }
      return { name: `${item.group}/${subItem.name}` };
    },
    toggleMenu(id) {
        //alert(id);
        document.querySelector(`#${id}`).classList.toggle("collapse-ul");
    }
  }
};
</script>

<style lang="stylus">
// @import '../../node_modules/vuetify/src/stylus/settings/_elevations.styl';
#appDrawer {
  overflow: hidden;

  .drawer-menu--scroll {
    height: calc(100vh - 48px);
    overflow: auto;
  }
}

.bg-white, .bg-white.v-toolbar.theme--light {
  background: #ffffff !important;
}
</style>




<style scoped>
@import "../assets/style/updated.css";

    .theme--light.v-icon {
      color: rgba(255, 255, 255) !important;
    }

    .theme--light.v-list {
      background: transparent;
      color: blue;
    }
    
    
</style>